var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(5)))));
	},
	"./base": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(17)]).then(() => (() => ((__webpack_require__(1023)))));
	},
	"./init-app": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(1093)))));
	},
	"./components": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(1064)))));
	},
	"./components/ui": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(11)]).then(() => (() => ((__webpack_require__(277)))));
	},
	"./containers": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(1061)))));
	},
	"./services": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(16)]).then(() => (() => ((__webpack_require__(1021)))));
	},
	"./providers": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(1058)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(11), __webpack_require__.e(6)]).then(() => (() => ((__webpack_require__(12)))));
	},
	"./store": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3)]).then(() => (() => ((__webpack_require__(982)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(14), __webpack_require__.e(20), __webpack_require__.e(19), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5), __webpack_require__.e(3), __webpack_require__.e(1)]).then(() => (() => ((__webpack_require__(9)))));
	},
	"./types": () => {
		return __webpack_require__.e(2).then(() => (() => ((__webpack_require__(7)))));
	},
	"./i18n": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(21)]).then(() => (() => ((__webpack_require__(1095)))));
	},
	"./decorators": () => {
		return __webpack_require__.e(10).then(() => (() => ((__webpack_require__(1096)))));
	},
	"./repositories": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(18), __webpack_require__.e(15), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(13), __webpack_require__.e(5)]).then(() => (() => ((__webpack_require__(1004)))));
	},
	"./modules": () => {
		return Promise.all([__webpack_require__.e(20), __webpack_require__.e(4)]).then(() => (() => ((__webpack_require__(1091)))));
	},
	"./application/settings": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(8), __webpack_require__.e(7), __webpack_require__.e(11), __webpack_require__.e(6), __webpack_require__.e(22)]).then(() => (() => ((__webpack_require__(1097)))));
	},
	"./pages": () => {
		return Promise.all([__webpack_require__.e(9), __webpack_require__.e(12)]).then(() => (() => ((__webpack_require__(1090)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});